import { useEffect, useState } from "react";
import api, { apiErrorMessage } from "@/api/client";
import { Loader2, Users, ClipboardCheck, Clock, AlertCircle } from "lucide-react";

export default function AdminOverview() {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get("/admin/dashboard/overview").then((r) => setData(r.data)).catch((e) => setError(apiErrorMessage(e)));
  }, []);

  if (error) return <div className="text-rose-600 text-sm font-semibold" data-testid="admin-overview-error">{error}</div>;
  if (!data) return <Loader2 className="w-6 h-6 animate-spin text-brand-accent" />;

  const cards = [
    { label: "Participantes matriculados", value: data.total_participants, icon: Users, cls: "text-brand-accent bg-brand-softBlue" },
    { label: "Diagnósticos completados", value: data.diagnostic_completed, icon: ClipboardCheck, cls: "text-emerald-600 bg-emerald-50" },
    { label: "En progreso", value: data.diagnostic_in_progress, icon: Clock, cls: "text-amber-600 bg-amber-50" },
    { label: "Pendientes", value: data.diagnostic_pending, icon: AlertCircle, cls: "text-brand-coral bg-orange-50" },
  ];

  return (
    <div className="space-y-8">
      <div>
        <h1 className="font-display text-2xl font-extrabold text-slate-900 tracking-tight">Resumen General</h1>
        <p className="text-sm text-slate-500 mt-0.5">Piloto 48 jefaturas intermedias · Programa ANID · INSIDE</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-testid="admin-overview-kpi-grid">
        {cards.map((c) => (
          <div key={c.label} className="bg-white rounded-2xl border border-slate-200/70 p-5 shadow-[0_1px_0_rgba(15,23,42,0.04),0_12px_24px_rgba(15,23,42,0.06)]">
            <div className={`w-9 h-9 rounded-lg flex items-center justify-center mb-3 ${c.cls}`}><c.icon className="w-[18px] h-[18px]" /></div>
            <div className="text-2xl font-extrabold text-slate-900" data-testid={`admin-overview-kpi-value-${c.label.split(" ")[0].toLowerCase()}`}>{c.value}</div>
            <div className="text-[11px] font-semibold text-slate-500 mt-0.5">{c.label}</div>
          </div>
        ))}
      </div>

      <div className="bg-white rounded-2xl border border-slate-200/70 p-6 shadow-[0_1px_0_rgba(15,23,42,0.04),0_12px_24px_rgba(15,23,42,0.06)]">
        <h3 className="font-display text-sm font-bold text-slate-900 mb-4">Actividades por semana</h3>
        <div className="overflow-x-auto">
          <table className="w-full text-xs" data-testid="admin-overview-activities-table">
            <thead>
              <tr className="text-left text-slate-400 uppercase text-[10px] border-b border-slate-200">
                <th className="py-2.5">Semana</th><th>Tema</th><th>Publicada</th><th>Realizadas</th><th>No realizadas</th><th>Borradores</th>
              </tr>
            </thead>
            <tbody>
              {data.activities_per_week.map((w) => (
                <tr key={w.week} className="border-b border-slate-100 hover:bg-slate-50/70 transition-colors">
                  <td className="py-3 font-bold text-slate-800">{w.week}</td>
                  <td className="text-slate-600">{w.topic}</td>
                  <td>{w.published ? <span className="text-emerald-600 font-bold">Sí</span> : <span className="text-slate-400">No</span>}</td>
                  <td className="font-bold text-slate-800">{w.realizado} / {w.total_participants}</td>
                  <td className="text-slate-600">{w.no_realizado}</td>
                  <td className="text-slate-600">{w.draft}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
